import React from 'react'
import styles from './GenreFilter.module.scss'

const GenreFilter = ({ genres, selectedGenre, onGenreChange }) => {
  return (
    <div className={styles.genreFilter}>
      <h4 className={styles.filterTitle}>Жанры</h4>
      
      <div className={styles.genreList}>
        <button 
          className={`${styles.genreButton} ${selectedGenre === '' ? styles.active : ''}`}
          onClick={() => onGenreChange('')}
        >
          Все жанры
        </button>
        
        {genres.map(genre => (
          <button
            key={genre.id}
            className={`${styles.genreButton} ${selectedGenre === genre.id ? styles.active : ''}`}
            onClick={() => onGenreChange(genre.id)}
          >
            {genre.name}
          </button>
        ))}
      </div>
    </div>
  )
}

export default GenreFilter